// extracted by mini-css-extract-plugin
module.exports = {"SideHeader":"SideHeader_SideHeader__uX_Dk","SideHeaderAnimation":"SideHeader_SideHeaderAnimation__14Ref","SideHeaderTextAnimation":"SideHeader_SideHeaderTextAnimation__27tmX"};